import { PaymentProviderType } from '@cvo/domain';
import type { SDKOptions } from '@airwallex/components-sdk';
import type { TenantConfig } from './tenant.model';

const tenantConfig: TenantConfig = {
  appName: 'Veloair',
  defaultCurrency: 'EUR',
  supportedLocales: [
    {
      name: 'English',
      code: 'en-US',
      dir: 'ltr',
      files: ['airports', 'cities',  'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.assets', 'veloair.personal'],
    },
    {
      code: 'ar-SA',
      dir: 'rtl',
      files: ['airports', 'cities',  'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.personal'],
    },
    {
      name: 'Castellano',
      code: 'es-ES',
      dir: 'ltr',
      files: ['airports', 'cities',  'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.personal'],
    },
    {
      code: 'zh-CN',
      dir: 'ltr',
      files: ['airports', 'cities',  'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.personal'],
    },
    {
      name: 'Русский',
      code: 'ru-RU',
      dir: 'ltr',
      files: ['airports', 'cities', 'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.personal'],
    },
    {
      name: 'Oʻzbekcha',
      code: 'uz-UZ',
      dir: 'ltr',
      files: ['airports', 'cities', 'countries', 'ui', 'veloair', 'veloair.catalog', 'veloair.personal'],
    },
  ],
  defaultLocale: 'en-US',
  fallbackLocale: 'en-US',
  prices: {
    payloadDecimals: 2,
  },
  payments: {
    providers: {
      recurrent: {
        type: PaymentProviderType.AIRWALLEX,
        options: {
          env: (process.env.AIRWALLEX_ENVIRONMENT as SDKOptions['env']) || 'demo',
        },
      },
      oneTime: {
        type: PaymentProviderType.SPREEDLY,
        options: {
          environment: process.env.SPREEDLY_ENV_KEY || '',
          sdkUrl: process.env.SPREEDLY_SDK_URL || '',
        },
      },
    },
  },
};

export default tenantConfig;
